import BreadCrumbs from 'components/breadcrumbs'
import PMBPagination from 'components/PMBPagination'
import { TableComponent as DataTable } from 'components/TableComponent'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, CardText } from 'reactstrap'
import { setFetchOption } from './eventPartnerSlice'
import { useFetchEventPartnerQuery } from './eventPartnerApiSlice'
import CustomButton from 'components/Buttons/CustomButton'
import { URL_EVENT_PARTNER, URL_EVENT_PARTNER_FORM } from 'utils/pathUrl'
import { useNavigate } from 'react-router-dom'
import { Edit2 } from 'react-feather'
import PMBTooltip from 'components/PMBTooltip'
import { ResponsiveActionButton } from 'components/Buttons'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import { useState } from 'react'
import { useDebounce } from 'helpers'
import { Can } from 'context/Acl'
import { BUSINESS_EVENT_PARTNER, MANAGE } from 'utils/subjectActions'

const ListEventPartner = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchInput, setSearchInput] = useState('')

  const { tag } = useSelector((s) => s.eventPartner)
  const res = useFetchEventPartnerQuery(
    {
      ...tag,
    },
    { skip: !tag },
  )

  const columns = [
    {
      name: <span>Nama</span>,
      selector: (row) => row.name,
      grow: 2,
      // sortField: 'name',
      // sortable: true,
      cell: (row) => <div data-testid={`event-partner-row-${row.id}`}>{row?.name}</div>,
    },
    {
      name: <span>Nomor Telefon</span>,
      selector: (row) => row.phone,
      grow: 2,
      // sortField: 'phone',
      // sortable: true,
      cell: (row) => <div>{row?.phone}</div>,
    },
    {
      name: <span>Alamat</span>,
      selector: (row) => row.address,
      grow: 2,
      // sortField: 'address',
      sortable: true,
      cell: (row) => <div>{row?.address}</div>,
    },
    {
      name: '',
      grow: 1,
      cell: (row) => (
        <>
          <Can I={MANAGE} this={BUSINESS_EVENT_PARTNER}>
            <ResponsiveActionButton
              iconName="edit"
              label="Ubah"
              onClick={() => {
                navigate(URL_EVENT_PARTNER_FORM, { state: row })
              }}
              testId={`event-partner-edit-${row.id}`}
            />
          </Can>
        </>
      ),
    },
  ]

  const handleSort = (column, direction) => {
    dispatch(
      setFetchOption({
        sortby: column.sortField,
        sortdir: direction === 'asc' ? 'desc' : 'asc',
      }),
    )
  }

  const debouncedSearch = useDebounce((value) => {
    dispatch(
      setFetchOption({
        page: 0,
        search: value,
      }),
    )
  }, 600)

  const onHandleSearchChange = (value) => {
    setSearchInput(value ?? '')
    debouncedSearch(value ?? '')
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ' && tag?.s.length === 0) {
      e.preventDefault()
    }
  }

  return (
    <div className="w-100 px-3 pb-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs breadCrumbActive={'Partner Event'} />
      </div>
      <Card className="border-0 shadow-sm">
        <CardBody>
          <DataTable
            columns={columns}
            data={res?.data?.items}
            progressPending={res?.isLoading || res?.status === 'pending'}
            responsive
            persistTableHead
            defaultSortFieldId={1}
            defaultSortAsc={false}
            sortServer
            onSort={handleSort}
            pagination
            paginationServer
            paginationComponent={(props) => (
              <PMBPagination
                rowCount={res?.data?.totalItems}
                currentPage={tag?.page}
                rowsPerPage={tag?.size ?? 10}
                setCurrentPage={(e) => {
                  dispatch(setFetchOption({ page: e }))
                }}
                setRowsPerPage={(e) => {
                  dispatch(setFetchOption({ size: e }))
                }}
                props={props}
                testId="event-partner-pagination"
              />
            )}
            subHeader={true}
            subHeaderComponent={
              <div className="mb-3 w-100">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center w-100 mb-2">
                  <CardText tag="h5" className="mb-2 mb-md-0">
                    {'Partner Event'}
                  </CardText>

                  <Can I={MANAGE} this={BUSINESS_EVENT_PARTNER}>
                    <CustomButton
                      onClick={() => navigate(URL_EVENT_PARTNER_FORM)}
                      size="sm"
                      color="primary"
                      testId="event-partner-add-button"
                    >
                      + Tambah Partner Event
                    </CustomButton>
                  </Can>
                </div>

                <div className="d-flex w-100">
                  <PMBSearchInputGroup
                    label="Cari"
                    value={searchInput}
                    placeholder="Cari..."
                    onChange={(e) => onHandleSearchChange(e.target.value)}
                    maxWidth="100%"
                    onKeyDown={handleKeyDown}
                    testId="event-partner-search-input"
                  />
                </div>
              </div>
            }
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default ListEventPartner
